import { Chip, Text, NumberEasing, Card, Skeleton } from '@/components'
import { isDecimal } from '@/utils/number'
import { centsToDollars } from '@/utils/currency'
import CostCategoryAnnualSavingsModal from './CostCategoryAnnualSavingsModal'

export interface Props {
  label: string
  savingsAmountCents: number
  loading: boolean
  showInfoButton?: boolean
  hideIfNoSavings?: boolean
}

export default function CostCategorySavingsCard({
  label,
  savingsAmountCents,
  loading,
  showInfoButton = false,
  hideIfNoSavings = true,
}: Props) {
  const savingsAmount = centsToDollars(Math.abs(savingsAmountCents))
  const chipDecimals = isDecimal(savingsAmount) ? 2 : 0

  // Hide if zero savings (savings can be positive for annual or negative for month)
  if (!loading && hideIfNoSavings && savingsAmount <= 0) {
    return null
  }

  return (
    <Card className="p-4">
      <div className="flex items-center justify-between w-full">
        <div className="flex items-center gap-2">
          <Text variant="body1">{label}</Text>
          {showInfoButton && <CostCategoryAnnualSavingsModal />}
        </div>
        {loading ? (
          <Skeleton
            animation="wave"
            variant="rect"
            width={60}
            height={26}
            className="rounded-lg"
          />
        ) : (
          <Chip className="bg-themed-green-100 py-1 px-3 rounded-lg w-fit">
            <Text className="text-themed-green-700">
              +$
              <NumberEasing
                value={savingsAmount}
                decimals={chipDecimals}
                speed={400}
                ease="quintOut"
              />
            </Text>
          </Chip>
        )}
      </div>
    </Card>
  )
}
